// client/src/components/stories/StoryReader.js

import { useState } from 'react';
import Button from '../ui/Button.js';

export default function StoryReader({ story }) {
  const isHtml = story.contentformat === 'html';
  const pages = !isHtml ? (story.pages || [story.content]) : null;
  const [currentPage, setCurrentPage] = useState(0);

  return (
    <div className="max-w-3xl mx-auto">
      {/* Story Header */}
      <div className="text-center mb-8">
        <h1 className="font-display text-3xl text-royal-900 dark:text-gold mb-1">{story.title}</h1>
        {story.author && <p className="text-royal-500 dark:text-royal-200 italic mt-1">by {story.author}</p>}
        {story.subcategoryname && (
          <p className="text-royal-400 dark:text-royal-200 text-sm mt-2">{story.categoryname} — {story.subcategoryname}</p>
        )}
      </div>

      {/* Parchment Content Area */}
      <div className="story-parchment rounded-2xl overflow-hidden shadow-xl">
        <div className="story-parchment-inner px-6 sm:px-10 md:px-14 py-10">
          {isHtml ? (
            <div
              className="story-content"
              dangerouslySetInnerHTML={{ __html: story.contenthtml }}
            />
          ) : (
            <div className="story-content whitespace-pre-line">
              {pages[currentPage]}
            </div>
          )}
        </div>
      </div>

      {/* Page Navigation — only for text format */}
      {!isHtml && pages && pages.length > 1 && (
        <div className="flex items-center justify-between mt-6">
          <Button
            variant="outline"
            className="text-sm py-2 px-4"
            onClick={() => setCurrentPage((p) => p - 1)}
            disabled={currentPage === 0}
          >
            &larr; Previous
          </Button>
          <span className="text-royal-500 dark:text-royal-200 text-sm">
            Page {currentPage + 1} of {pages.length}
          </span>
          <Button
            variant="outline"
            className="text-sm py-2 px-4"
            onClick={() => setCurrentPage((p) => p + 1)}
            disabled={currentPage >= pages.length - 1}
          >
            Next &rarr;
          </Button>
        </div>
      )}
    </div>
  );
}